import React from 'react';
import styled, { css } from 'styled-components';

const IconWrapper = styled.svg`
  //width: 100px;
  width: ${props =>
    props.width ||
    css`
      100px;
    `}px;
  height: 100px;
  background-color: ${props =>
    props.bgColor ||
    css`
      ${props.theme.colors.transparent};
    `}; 

  {use} {
    fill: ${props =>
      props.fillColor ||
      css`
        ${props.fillColor};
      `};
  }
  
   
`;

class Icon extends React.Component {
  render() {
    const { id, fillColor, bgColor, width } = this.props;
    const svgPath = `/assets/images/sprites.svg#${id}`;
    return (
      <IconWrapper fillColor={fillColor} bgColor={bgColor} width={width}>
        <use xlinkHref={svgPath} />
      </IconWrapper>
    );
  }
}

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js